import { AtSymbolIcon, PhoneIcon } from '@heroicons/react/24/outline';
import { StyledLink } from '../ui';
import { useTranslation } from 'react-i18next';
import { OfferRow } from '../offer-row';
import { useWindowSize } from 'usehooks-ts';

export interface IHeaderProps {
  actions?: React.ReactNode;
}

export function Header(props: IHeaderProps) {
  const { t } = useTranslation();
  const { width = 0 } = useWindowSize();

  return (
    <header className="pb-4">
      <div className="grid grid-cols-[1fr_auto_1fr] sm:hidden w-full p-2 items-center">
        <div className="flex items-center justify-start gap-2">
          <StyledLink
            href="tel:+4333332801"
            classNames="flex items-center gap-1"
          >
            <PhoneIcon className="w-4 h-4"></PhoneIcon>
            <span className="sr-only">{t('header.call')}</span>
          </StyledLink>

          <StyledLink
            href="mailto:info@mandira-ayurveda.at"
            classNames="flex items-center gap-1"
          >
            <AtSymbolIcon className="w-4 h-4"></AtSymbolIcon>
            <span className="sr-only">{t('header.mail')}</span>
          </StyledLink>
        </div>

        <div className="flex items-center justify-center shrink-0">
          <img
            className="h-5 m-2"
            alt="Logo Mandira"
            src="https://cdn.mandira-ayurveda.at/images/text/2024/black.png"
          ></img>
        </div>

        <div className="flex items-center justify-end">
          {props.actions}
        </div>
      </div>

      <OfferRow></OfferRow>

      <div className="container px-2 hidden sm:grid grid-cols-[1fr_auto_1fr] items-center mt-6 sm:mt-0">
        <div />

        <div className="flex justify-center">
          {width >= 640 ? (
            <a href="https://www.mandira-ayurveda.at">
              <img
                className="h-16"
                alt="Logo Mandira"
                src="https://cdn.mandira-ayurveda.at/images/logo/2024/dark_cyan_text_black.png"
              ></img>
              <span className="sr-only">{t('header.to-homepage')}</span>
            </a>
          ) : (
            <a href="https://www.mandira-ayurveda.at">
              <img
                className="h-8"
                alt="Logo Mandira"
                src="https://cdn.mandira-ayurveda.at/images/icon/2024/dark_cyan.png"
              ></img>
              <span className="sr-only">{t('header.to-homepage')}</span>
            </a>
          )}
        </div>
        <div id="header-actions" className="hidden sm:flex gap-2 justify-end ">
          <StyledLink
            href="tel:+4333332801"
            classNames="flex items-center gap-1"
          >
            <PhoneIcon className="w-4 h-4"></PhoneIcon> {t('header.call')}
          </StyledLink>

          <StyledLink
            href="mailto:info@mandira-ayurveda.at"
            classNames="hidden md:flex items-center gap-1"
          >
            <AtSymbolIcon className="w-4 h-4"></AtSymbolIcon> {t('header.mail')}
          </StyledLink>

          {props.actions}
        </div>
      </div>
    </header>
  );
}

export default Header;
